exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vfm--fixed[data-v-1aafb7cc]{position:fixed}.vfm--absolute[data-v-1aafb7cc]{position:absolute}.vfm--inset[data-v-1aafb7cc]{top:0;right:0;bottom:0;left:0}.vfm--overlay[data-v-1aafb7cc]{background-color:rgba(0,0,0,.5)}.vfm--prevent-none[data-v-1aafb7cc]{pointer-events:none}.vfm--prevent-auto[data-v-1aafb7cc]{pointer-events:auto}.vfm--cursor-pointer[data-v-1aafb7cc]{cursor:pointer}.vfm--cursor-auto[data-v-1aafb7cc]{cursor:auto}.vfm-enter-active[data-v-1aafb7cc],.vfm-leave-active[data-v-1aafb7cc]{transition:opacity .2s}.vfm-enter[data-v-1aafb7cc],.vfm-leave-to[data-v-1aafb7cc]{opacity:0}", ""]);

// exports
